<div class="modal-header b pb-0 px-5 pt-5">
  <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Edit Profile</h5>
  <span type="button" class="close font-weight-normal f-16 ms-auto" data-bs-dismiss="modal" aria-bs-label="Close"
    (click)="modalService.dismissAll()">
   <i class="fas fa-times f-14 text-black"></i>
</span>
</div>
<div class="modal-body mb-4 px-5 pb-0">
  <form [formGroup]="profile_form">
  <div class="row">
    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500" style="color: #484B59;">First Name<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-1" type="text" placeholder="Enter First Name" class="wc-form-control nobg" formControlName="fname">
        <p *ngIf="profile_form.get('fname').errors?.required && (profile_form['controls'].fname.dirty || profile_form['controls'].fname.touched)"
          [ngClass]="['f-12','mt-1','text-danger']">First Name is required</p>
        <p *ngIf="profile_form.get('fname').errors?.pattern" [ngClass]="['f-12','mt-1','text-danger']">Only Alphabets
          Allowed</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500">Last Name<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-2" type="text" placeholder="Enter Last Name" class="wc-form-control nobg" formControlName="lname">
        <p *ngIf="profile_form.get('lname').errors?.required && (profile_form['controls'].lname.dirty || profile_form['controls'].lname.touched)"
          [ngClass]="['f-12','mt-1','text-danger']">Last Name is required</p>
        <p *ngIf="profile_form.get('lname').errors?.pattern" [ngClass]="['f-12','mt-1','text-danger']">Only Alphabets
          Allowed</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500">Designation<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-3" type="text" placeholder="Enter Designation" class="wc-form-control nobg" formControlName="designation">
        <p *ngIf="profile_form.get('designation').errors?.required && (profile_form['controls'].designation.dirty || profile_form['controls'].designation.touched)"
          [ngClass]="['f-12','mt-1','text-danger']">Designation is required</p>
          <p *ngIf="profile_form['controls'].designation.hasError('pattern') && (profile_form['controls'].designation.dirty || profile_form['controls'].designation.touched)" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500">Company Name<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-4" type="text" placeholder="Enter Company Name" class="wc-form-control nobg" formControlName="cname">
        <p *ngIf="profile_form.get('cname').errors?.required && (profile_form['controls'].cname.dirty || profile_form['controls'].cname.touched)"
          [ngClass]="['f-12','mt-1','text-danger']">Company Name is required</p>
          <p *ngIf="profile_form['controls'].cname.hasError('pattern') && (profile_form['controls'].cname.dirty || profile_form['controls'].cname.touched)" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500">Phone Number<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-5" type="text" placeholder="Enter Phone Number" class="wc-form-control nobg" formControlName="mobileno">
        <p *ngIf="profile_form.get('mobileno').errors?.required && (profile_form['controls'].mobileno.dirty || profile_form['controls'].mobileno.touched)"
          [ngClass]="['f-12','mt-1','text-danger']">Mobile No is required</p>
        <p class="text-danger f-12 pt-1" *ngIf="profile_form['controls'].mobileno.hasError('pattern')">
          Only numbers and plus(+) allowed
        </p>
        <p class="text-danger f-12 pt-1"
          *ngIf="profile_form.get('mobileno').errors?.minlength || profile_form.get('mobileno').errors?.maxlength">
          Please Enter valid Mobile No.
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="position-relative mb-4">
        <label class="font-weight-500">Enter Email<span class="text-danger">*</span></label>
        <input data-testid="auto-app-edit-profile-input-6" type="text" placeholder="Enter Your Email Id" class="wc-form-control nobg" formControlName="emailid">
      </div>
    </div>

    <div class="col-md-6">
      <div class="position-relative mb-4">
         <label class="font-weight-500">Region Preference</label>

             <select data-testid="auto-app-edit-profile-select-1" name="location" formControlName="region"
            class="wc-form-control position-relative no-outline inputheight wc-select">
                <option [value]="continent" *ngFor="let continent of continentsList">{{continent | titlecase}} </option>

            </select>
      </div>
    </div>
  </div>
</form>
  <div class="modal-footer b pb-5">
    <button data-testid="auto-app-edit-profile-button-1" type="button" class="btn-trms-small m-auto" data-dismiss="modal"
      (click)="saveDetails()">Save</button>
</div>
